import axios from 'axios';
import LocalStorageService from '../application/features/common/local-storage-service';
import { logout } from '../application/features/auth/authSlice';
import { refreshTokenAsync } from '../application/features/auth/authThunk';
const baseURL = process.env.REACT_APP_API_BASE_URL;
let refreshing_token = null;
export const tenderAIAPi = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
        'Accept-Language': 'en'
    }
});
tenderAIAPi.interceptors.request.use(async (config) => {
    const accessToken = LocalStorageService.getAccessToken();
    if (accessToken === null && config.url === 'auth/refresh') {
        const { store } = await import('../application/store');
        store.dispatch(logout());
        window.location.href = '/login';
        const controller = new AbortController();
        const cfg = {
            ...config,
            signal: controller.signal
        };
        controller.abort('Refresh token request cancelled');
        return cfg;
    }
    if (config.url !== 'auth/refresh' && config.url !== 'account/authenticate') {
        if (config.headers)
            config.headers.set('Authorization', `Bearer ${accessToken}`);
    }
    return config;
});
tenderAIAPi.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const config = error.config;
    if (error.response && error.response.status === 401 && !config._retry) {
        if (error.config?.url === 'account/authenticate' ||
            error.config.url === 'account/forgot-password') {
            return Promise.reject(error);
        }
        else if (error.config.retry || error.config?.url === 'auth/refresh') {
            refreshing_token = null;
            const { store } = await import('../application/store');
            store.dispatch(logout());
            window.location.href = '/login';
        }
        else {
            config._retry = true;
            try {
                refreshing_token = refreshing_token ? refreshing_token : refresh_token();
                await refreshing_token;
                return tenderAIAPi(config);
            }
            catch (err) {
                refreshing_token = null;
                return Promise.reject(err);
            }
        }
    }
    refreshing_token = null;
    return Promise.reject(error);
});
async function refresh_token() {
    if (!refreshing_token) {
        const { store } = await import('../application/store');
        refreshing_token = store.dispatch(refreshTokenAsync()).unwrap();
    }
    return refreshing_token;
}
